
import React, { Component, PropTypes } from 'react';
import Dropzone from 'react-dropzone';

import axios from 'axios';

import InputDropzoneDisplay from './dropzoneDisplay';

export default class InputDropzoneGrid extends Component {
	static propTypes = {
		path: PropTypes.string.isRequired,
		inputs: PropTypes.array.isRequired,
		disableClick: PropTypes.bool,
		multiple: PropTypes.bool,
		accept: PropTypes.string,
		recommended: PropTypes.shape({
			width: PropTypes.number.isRequired,
			height: PropTypes.number.isRequired,
		}),
	};

	static defaultProps = {
		inputs: [],
		disableClick: false,
		multiple: false,
		accept: '',
		recommended: {
			width: 0,
			height: 0,
		},
	};

	render() {
		let className = 'form-dropzone-grid pixel-pattern pixel-pattern--10';
		let { inputs } = this.props;

		if (inputs.length !== 3) {
			return false;
		}

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		if (!inputs.length) {
			return false;
		}

		// 487x280 >>         >> 290 x 167
		// 877x560 >> 522x326 >> 522 x 333
		//
		// aspect: ,624521073

		// multiplier: ,595210946
		//
		// 522 x 334
		// 290 x 167

		return (
			<div className={className}>
				<div className='form-dropzone-grid__container'>
					<div className='form-dropzone-grid__lcol'>
						<InputDropzoneDisplay {...this.props} key={inputs[0].name} name={inputs[0].name} preview={inputs[0].preview} aspect={inputs[0].aspect} recommended={inputs[0].recommended} />
						<InputDropzoneDisplay {...this.props} key={inputs[1].name} name={inputs[1].name} preview={inputs[1].preview} aspect={inputs[1].aspect} recommended={inputs[1].recommended} />
					</div>
					<div className='form-dropzone-grid__rcol'>
						<InputDropzoneDisplay {...this.props} key={inputs[2].name} name={inputs[2].name} preview={inputs[2].preview} aspect={inputs[2].aspect} recommended={inputs[2].recommended} />
					</div>

					<div className='cf'></div>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/dropzone/dropzoneGrid.js
 **/